import { NavLink } from 'react-router-dom'; // Cambiamos Link por NavLink
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import '../styles/Topbar.css';

export default function Topbar() {
  const { roles, user, logout } = useContext(AuthContext);
  const canSeeFacturacion = roles.includes('ADMIN') || roles.includes('DOCTOR');

  return (
    <header className="topbar">
      <div className="topbar-brand">
        <span className="brand-dot"></span>
        <strong>{user || "Usuario"}</strong>
      </div>
      
      <nav className="topbar-nav">
        <NavLink to="/dashboard" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Inicio</NavLink>
        <NavLink to="/pacientes" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Pacientes</NavLink>
        <NavLink to="/calendario" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Calendario</NavLink>
        {canSeeFacturacion && <NavLink to="/facturacion/general" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Facturación</NavLink>}
        {canSeeFacturacion && <NavLink to="/auditoria" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Auditoría</NavLink>}
      </nav>

      <div className="topbar-right">
        <button className="logout-button" onClick={logout}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '8px'}}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
          Salir
        </button>
      </div>
    </header>
  );
}